import type { ChangeEvent, FC } from "react";

import { InputTextStyle } from "../../../../documentation/styles/InputStyle";
import type { FormInputProps } from "../../types/types";

interface TextInputProps extends FormInputProps<string> {
    readOnly?: boolean;
    placeholder?: string;
}

export const TextInput: FC<TextInputProps> = ({ onChange, readOnly, placeholder, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    return (
        <InputTextStyle
            className={readOnly ? "aevi-input aevi-input-text aevi-input-disabled" : "aevi-input aevi-input-text"}
            disabled={readOnly}
            onChange={onValueChange}
            placeholder={placeholder}
            {...restProps}
        />
    );
};
